import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import {
  BeneficiariesViewModel,
  ClientDetailsGetBeneficiariesRequest,
  ResultOfBeneficiariesViewModel
} from 'bff/client';

export const useInvalidateBeneficiaries = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['beneficiaries'],
      refetchType: 'all'
    });
};

export const useBeneficiariesQuery = (
  request: ClientDetailsGetBeneficiariesRequest,
  isEnabled: boolean
): UseQueryResult<BeneficiariesViewModel['beneficiariesList'] | undefined, Error> => {
  const { clientDetailsApi } = useApiClient();

  return useQuery<
    ResultOfBeneficiariesViewModel,
    Error,
    BeneficiariesViewModel['beneficiariesList'] | undefined
  >({
    queryKey: ['beneficiaries', request.clientId],
    queryFn: () => clientDetailsApi.clientDetailsGetBeneficiaries(request),
    select: (response) => response.data?.beneficiariesList,
    enabled: isEnabled
  });
};
